import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];
  const operation = properties.operation || 'get';

  // Key-based operations require a key
  if (['delete', 'get', 'set', 'increment'].includes(operation)) {
    if (!properties.key || properties.key.trim() === '') {
      errors.push({
        key: 'key',
        message: 'Key is required',
      });
    }
  }

  // Set operation requires a value
  if (operation === 'set') {
    if (!properties.value && properties.value !== 0) {
      errors.push({
        key: 'value',
        message: 'Value is required',
      });
    }

    if (properties.expire && (!properties.ttl || properties.ttl < 1)) {
      errors.push({
        key: 'ttl',
        message: 'TTL must be at least 1 second',
      });
    }
  }

  // List operations require a list name
  if (['push', 'pop', 'listLength'].includes(operation)) {
    if (!properties.list || properties.list.trim() === '') {
      errors.push({
        key: 'list',
        message: 'List name is required',
      });
    }
  }

  // Push operation requires data
  if (operation === 'push') {
    if (!properties.messageData && properties.messageData !== 0) {
      errors.push({
        key: 'messageData',
        message: 'Data is required',
      });
    }
  }

  // Publish operation requires channel and message
  if (operation === 'publish') {
    if (!properties.channel || properties.channel.trim() === '') {
      errors.push({
        key: 'channel',
        message: 'Channel is required',
      });
    }
    if (!properties.messageData && properties.messageData !== 0) {
      errors.push({
        key: 'messageData',
        message: 'Message is required',
      });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
